/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LanguageSwitcher from '../../features/LanguageSwitcher';
import { languageConfig } from '../../../settings/i18n/languages';
import { RootState } from '../../../redux/reducers';
import { BrowserRouter as Router } from 'react-router-dom';
import CustomTabs from '../../features/CustomTabs/CustomTabs';
import { TopFrame, Button } from 'react-inv-forms';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux';
import { TeamOutlined } from '@ant-design/icons';
import isEmpty from 'lodash.isempty';
import withAccessProvider, { WithAccessProviderProps } from '../../../hoc/withAccessProvider';
import { checkToken, logout } from '../../../redux/auth/actions';
import authAsActions from '../../../redux/authAs/actions';
import { toggleNavPanel, setLanguage, redirectToAdminPanel } from '../../../redux/appConfig/actions';
import { getIsCheckingApiStatus, getMaintenanceMode } from '../../../redux/appConfig/selectors';
import { StyledApp, TabsContainer } from './App.style';
import GenerateProtocolModal from '../../modals/GenerateProtocolModal';
import { SuperTeacherPanel } from '../../features/SuperTeacherPanel';
import { userPanelTranslations } from '../../../settings/i18n/translations/packets';
import SigninAsTeacherModal from '../../modals/SigninAsTeacherModal';
import SignMarksModal from '../../modals/SignMarksModal';
import InputCodeMarksModal from '../../modals/InputCodeMarksModal';
import ChooseEmployeeModal from '../../modals/ChooseEmployeeModal';
import InputEmployeeCodeMarksModal from '../../modals/InputEmployeeCodeMarksModal';
import SigninMarksLoaderModal from '../../modals/SigninMarksLoaderModal';
import PairEffectsModal from '../../modals/PairEffectsModal';
import ChangeLogModal from '../../modals/ChangeLogModal';
import CopyFinalMarksModal from '../../modals/CopyFinalMarksModal';
import MaintenanceModePage from '../../views/MaintenanceModePage';
import { FlexBox } from '../../../styles/tabContainers';
import { environments } from '../../../settings';
import { Language } from '../../../settings/i18n/languages';

const { openSigninAsTeacherModal, logoutToSuperteacher } = authAsActions;

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

export type Props = MapStateToProps & MapDispatchToProps & WithAccessProviderProps;

/**
 * Główny komponent aplikacji.
 * Dostarcza obsługę wielojęzykowości do aplikacji,
 * konfigurację języka dla paczki Ant Design oraz mapuje modale dostępne globalnie w aplikacji.
 *
 */
export const App: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    props.checkToken();
  }, []);
  const role = props.findRole();

  const addAdditionalInfo = (): string | null => {
    return process.env.REACT_APP_ENVIRONMENT === environments.DEVELOPMENT
      ? t('ENVIRONMENT_DEVELOPMENT')
      : process.env.REACT_APP_ENVIRONMENT === environments.STAGE
      ? t('ENVIRONMENT_STAGE')
      : null;
  };

  return (
    <StyledApp>
      {props.loading || props.isCheckingApiStatus ? (
        <FlexBox justify='center' alignItems='center' fullheight fullwidth>
          <img src={require('../../../images/logo_full_color.svg')} alt='logo' />
        </FlexBox>
      ) : !isEmpty(props.maintenanceMode) ? (
        <MaintenanceModePage />
      ) : (
        <React.Fragment>
          <TopFrame
            user={{ ...props.user, role: t(role.translationKey) }}
            onLogout={props.logout}
            translations={userPanelTranslations}
            currentLanguage={props.currentLanguage}
            parent={props.parent}
            opened={props.openedMainNavPanel}
            toggleOpen={props.toggleNavPanel}
            additionalInfo={addAdditionalInfo()}
          >
            <div className='top_frame_children'>
              <div>
                {props.checkAccess('supernauczyciel-panel') || props.superNauczycielLogged ? (
                  <SuperTeacherPanel
                    onOpen={props.openSigninAsTeacherModal}
                    onLogout={props.logoutToSuperteacher}
                    logged={props.superNauczycielLogged}
                  />
                ) : null}
                {props.user.isCan === 1 && (
                  <Button onClick={props.redirectToAdminPanel} icon={<TeamOutlined />} data-cy='btnAdminPanel'>
                    {t('ADMIN_PANEL')}
                  </Button>
                )}
              </div>
              <LanguageSwitcher
                currentLanguage={props.currentLanguage}
                setLanguage={props.setLanguage}
                languages={languageConfig}
              />
            </div>
          </TopFrame>
          <TabsContainer>
            <Router>
              <CustomTabs />
            </Router>
          </TabsContainer>

          {/* globalnie używane modale */}
          <SigninAsTeacherModal />
          <SignMarksModal />
          <InputCodeMarksModal />
          <ChooseEmployeeModal />
          <InputEmployeeCodeMarksModal />
          <SigninMarksLoaderModal opened={props.mainMarksLoader} />
          <GenerateProtocolModal />
          <PairEffectsModal />
          <ChangeLogModal />
          <CopyFinalMarksModal />
        </React.Fragment>
      )}
    </StyledApp>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentLanguage: state.AppConfig.currentLanguage,
  user: state.Auth.user,
  loading: state.Auth.loading,
  superNauczycielLogged: !!state.Auth.parent,
  parent: state.Auth.parent,
  openedMainNavPanel: state.AppConfig.navPanel.opened,
  mainMarksLoader: state.Marks.mainLoader,
  maintenanceMode: getMaintenanceMode(state),
  isCheckingApiStatus: getIsCheckingApiStatus(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  checkToken: () => dispatch(checkToken()),
  setLanguage: (language: Language) => dispatch(setLanguage(language)),
  logout: () => dispatch(logout()),
  openSigninAsTeacherModal: () => dispatch(openSigninAsTeacherModal()),
  logoutToSuperteacher: () => dispatch(logoutToSuperteacher()),
  toggleNavPanel: () => dispatch(toggleNavPanel()),
  redirectToAdminPanel: () => dispatch(redirectToAdminPanel()),
});

export default compose<any>(connect(mapStateToProps, mapDispatchToProps), withAccessProvider)(App);
